import getTargetValue from './getTargetValue';

export default (formState: any, setFormState: any) => (e: any) => {
  setFormState({
    ...formState,
    [e.target.name]: getTargetValue(e),
  });
};
